import type { MaybeRef } from "vue"
import type { ServerResponse } from "@/http"
import type { ITemplateEventVaultResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { TemplateEventVault } from "@/models"

interface IEventsListForTemplateResponse {
  EventTemplateID: number
  EventVaults: ITemplateEventVaultResponse[]
}

export async function listEventsForTemplate(templateId?: number, hostAccountId?: number) {
  if (!templateId) {
    throw new Error(
      "Missing `templateId` when attempting to list events to apply to. Please ensure `templateId` is provided.",
    )
  }

  const endpoint = hostAccountId
    ? `api/template/${templateId}/events?hostAccountId=${hostAccountId}`
    : `api/template/${templateId}/events`

  const response = await axios.get<ServerResponse<IEventsListForTemplateResponse>>(endpoint)

  return response.data.Data?.EventVaults?.map(event => TemplateEventVault.fromResponse(event)) ?? []
}

export function useListEventsForTemplate(templateId?: MaybeRef<number | undefined>, hostAccountId?: MaybeRef<number>) {
  return useQuery({
    queryKey: ["listEventsForTemplate", templateId, hostAccountId],
    queryFn: () => listEventsForTemplate(toValue(templateId)!, toValue(hostAccountId)),
    enabled: !!toValue(templateId),
  })
}
